import client from './client';
import { CrewWorkDetail, CrewWorkList, CrewWorkSupervisorOption } from '../interfaces/CrewWork';

const BASE = '/admin/crewWork';

/** Supervisors the caller may open (scoped server-side), already sorted and name-formatted. */
export const getCrewWorkSupervisors = async (): Promise<CrewWorkSupervisorOption[]> => {
  const response = await client.get(`${BASE}/supervisors`);
  return response.data?.supervisors ?? [];
};

/** One row per in-scope supervisor with the week's crew totals. */
export const getCrewWorkList = async (payPeriodID: number): Promise<CrewWorkList> => {
  const response = await client.get(`${BASE}/list`, { params: { payPeriodID } });
  return response.data;
};

/** One supervisor's crew for the week: employee -> job -> day -> punches. 403 out of scope, 404 unknown. */
export const getCrewWorkDetail = async (
  employeeID: number,
  payPeriodID: number
): Promise<CrewWorkDetail> => {
  const response = await client.get(`${BASE}/supervisor/${employeeID}`, { params: { payPeriodID } });
  return response.data;
};
